import styled from 'styled-components';
import { BaseContainer } from '../../../styles/Container';

export const ThumbImage = {
  position: 'absolute',
  maxWidth: '100%',
  width: '100%',
  height: 'auto',
  top: '50%',
  left: '50%',
  transform: 'translate( -50%, -50%)',
  borderRadius: 100,
} as React.CSSProperties;

export const TestimonyStyle = styled.div`
  img {
    max-width: 100% !important;
  }
`;

export const Wrapper = styled.div`
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: ${(props) => props.theme.colors.darkText};
    margin: 15px 0;
  }

  p,
  span {
    color: ${(props) => props.theme.colors.darkTextPale};
    line-height: 1.8;
    margin: 10px 0;
  }

  bold,
  b,
  strong,
  a {
    text-decoration-color: ${(props) => props.theme.colors.newBorder};
    font-weight: 500 !important;
    color: ${(props) => props.theme.colors.primary};
  }
`;

export const Post = styled.div`
  padding-bottom: 60px;
  > div:first-of-type {
    max-height: 650px;
  }
  display: flex;
  flex-direction: column;
  div:not(:first-child) {
    max-width: 1200px;
    margin: auto;
  }
  p {
    margin-top: 1em !important;
    margin-bottom: 1em !important;
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    padding-top: 1em;
  }
  div:last-child {
    h2 {
      padding: 0;
    }
  }
  .image {
    width: 100%;
    padding-top: 43%;
    min-height: 50%;
    overflow: hidden;
    position: relative;
  }
  .image img {
    width: 100%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    object-fit: cover;
  }
`;

export const PostContent = styled(BaseContainer)`
  flex-direction: column;
  padding: 0;
  h1 {
    margin-bottom: 0;
  }
  span {
    padding-left: 3px;
    padding-top: 8px;
    font-size: 0.8em;
  }
  > div:first-child {
    padding: 0 26px;
    padding-bottom: 16px;
  }
`;

export const Author = styled.div`
  border: ${(props) => props.theme.border.borderDark};
  border-radius: ${(props) => props.theme.border.borderRadius};
  display: flex;
  align-items: flex-start;
  position: relative;
  max-width: 1200px;
  width: 100%;
  margin: auto;
  margin-top: 40px;
  padding: 40px 26px;

  /* Divs internos */
  > div:first-child {
    img {
      border-radius: 50%;
      width: 65px;
      height: 65px;
    }
  }
  > div:last-child {
    /* Div com texto */
    :nth-of-type(2) {
      flex: 1;
      margin-left: 14px;
      h3,
      p {
        color: ${(props) => props.theme.colors.darkTextPale};
        font-weight: 400;
        margin: 0 !important;
        strong {
          font-weight: 600;
        }
      }
      h3 {
        color: ${(props) => props.theme.colors.darkText};
        font-weight: 500;
        padding: 0 !important;
      }
    }
  }

  .social-media {
    display: flex;
    gap: 2px;
    margin-top: 4px;

    svg {
      color: ${(props) => props.theme.colors.darkText};
      font-size: 24px;
    }
  }
`;

export const ImageWrapper = styled.div`
  width: 100%;
  overflow: hidden;
  padding-top: 80px;

  img {
    width: 100%;
    object-fit: cover;
    height: auto;
  }
`;

export const PublishedWrapper = styled.div`
  text-align: left;
  margin: auto;
  padding: 40px 0;

  h1 {
    margin-bottom: 0px;
    color: ${(props) => props.theme.colors.darkText};
  }

  span {
    padding-left: 3px;
    padding-top: 8px;
    color: ${(props) => props.theme.colors.darkText};
    font-size: 0.8em;
  }

  @media screen and (max-width: 1250px) {
    padding: 0 26px;
  }
`;
